import { Button, Input, Modal, ModalDialog } from "@mui/joy";
import React, { useEffect, useRef, useState } from "react";
import { postFetch } from "../../../../../fetch/fetch";

const EditPayLinkInfoModal = (props: any) => {

    const [studentName, setStudentName] = useState<string>("");
    const [studentPhoneNumber, setStudentPhoneNumber] = useState<string>("");
    const [parentPhoneNumber, setParentPhoneNumber] = useState<string>("");
    const [paymentMethod, setPaymentMethod] = useState<string>("");
    const [loading, setLoading] = useState<boolean>(false);

    const studentPhoneRef = useRef<any>(null);
    const parentPhoneRef = useRef<any>(null);

    const formatPhone = (raw: string, ref: any, setter: (v: string) => void) => {
        let digits = raw.replace(/\D/g, "");

        if (!digits.startsWith("010")) {
            if (digits.length <= 3) {
                digits = "010";
            } else {
                digits = "010" + digits.slice(3);
            }
        }

        if (digits.length < 3) {
            digits = "010";
        }

        if (digits.length > 11) {
            digits = digits.slice(0, 11);
        }

        let formatted = "";
        if (digits.length <= 3) {
            formatted = digits;
        } else if (digits.length <= 7) {
            formatted = digits.slice(0, 3) + "-" + digits.slice(3);
        } else {
            formatted = digits.slice(0, 3) + "-" + digits.slice(3, 7) + "-" + digits.slice(7);
        }

        setter(formatted);

        if (digits.length === 11) {
            ref?.current?.blur();
        }
    };

    useEffect(() => {
        if (props.open && props.selectedRow) {
            setStudentName(props.selectedRow.studentName || props.selectedRow.name || "");
            // DB에 저장된 값(대시 없음)을 포맷하여 표시
            const rawStudent = props.selectedRow.studentPhoneNumber || "";
            const rawParent = props.selectedRow.parentPhoneNumber || "";
            formatPhone(rawStudent || "010", null, setStudentPhoneNumber);
            formatPhone(rawParent || "010", null, setParentPhoneNumber);
            setPaymentMethod(props.selectedRow.paymentMethodRaw || "");
        }
    }, [props.open]);

    useEffect(() => {
        if (!props.open) {
            setStudentName("");
            setStudentPhoneNumber("");
            setParentPhoneNumber("");
            setPaymentMethod("");
            setLoading(false);
        }
    }, [props.open]);

    const isPhoneFull = (phone: string) => phone.replace(/\D/g, "").length === 11;

    const submit = async () => {
        try {
            if (!props.selectedRow) return;

            setLoading(true);

            const result: any = await postFetch("/dashboard/payments/managepayment/updatenewpaylinkinfo", {
                id: props.selectedRow.id,
                studentName,
                studentPhoneNumber: studentPhoneNumber.replace(/\D/g, ""),
                parentPhoneNumber: parentPhoneNumber.replace(/\D/g, ""),
                paymentMethod
            });

            setLoading(false);

            if (result.message === "success") {
                props.setUpdate(Math.random());
                props.handleClose();
            } else {
                alert("저장에 실패했습니다.");
            }

        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    };

    return (
        <Modal
            open={props.open}
            onClose={props.handleClose}
            slotProps={{
                backdrop: {
                    sx: {
                        backdropFilter: "none",
                        backgroundColor: "transparent",
                    },
                },
            }}
        >
            <ModalDialog
                sx={{
                    width: 500,
                    maxWidth: 500,
                    boxSizing: "border-box",
                    p: 2,
                    maxHeight: "90vh",
                    overflowY: "auto",
                }}
            >
                <div>
                    <div style={{ fontFamily: "Apple_B", fontSize: "20px", marginBottom: "18px" }}>
                        정보 수동 입력
                    </div>

                    <div style={{ fontFamily: "Apple_SB", fontSize: "15px", marginBottom: "6px" }}>
                        학생 이름
                    </div>
                    <Input
                        value={studentName}
                        onChange={(e) => setStudentName(e.target.value)}
                        placeholder="학생 이름"
                        style={{ width: "100%", marginBottom: "16px" }}
                    />

                    <div style={{ fontFamily: "Apple_SB", fontSize: "15px", marginBottom: "6px" }}>
                        학생 전화번호
                    </div>
                    <Input
                        ref={studentPhoneRef}
                        value={studentPhoneNumber}
                        onChange={(e) => formatPhone(e.target.value, studentPhoneRef, setStudentPhoneNumber)}
                        placeholder="010-0000-0000"
                        style={{ width: "100%", marginBottom: "16px" }}
                    />

                    <div style={{ fontFamily: "Apple_SB", fontSize: "15px", marginBottom: "6px" }}>
                        학부모 전화번호
                    </div>
                    <Input
                        ref={parentPhoneRef}
                        value={parentPhoneNumber}
                        onChange={(e) => formatPhone(e.target.value, parentPhoneRef, setParentPhoneNumber)}
                        placeholder="010-0000-0000"
                        style={{ width: "100%", marginBottom: "16px" }}
                    />

                    <div style={{ fontFamily: "Apple_SB", fontSize: "15px", marginBottom: "10px" }}>
                        결제수단
                    </div>
                    <div style={{ marginBottom: "24px" }}>
                        <Button
                            variant={paymentMethod === "onSite" ? "solid" : "outlined"}
                            color="neutral"
                            onClick={() => setPaymentMethod("onSite")}
                            style={{ marginRight: "8px" }}
                        >
                            현장결제
                        </Button>
                        <Button
                            variant={paymentMethod === "withdrawal" ? "solid" : "outlined"}
                            color="neutral"
                            onClick={() => setPaymentMethod("withdrawal")}
                            style={{ marginRight: "8px" }}
                        >
                            계좌이체
                        </Button>
                        <Button
                            variant={paymentMethod === "local" ? "solid" : "outlined"}
                            color="neutral"
                            onClick={() => setPaymentMethod("local")}
                        >
                            지역화폐
                        </Button>
                    </div>

                    <Button
                        fullWidth
                        variant="solid"
                        color="primary"
                        onClick={submit}
                        loading={loading}
                        disabled={!studentName || !isPhoneFull(studentPhoneNumber) || !isPhoneFull(parentPhoneNumber) || !paymentMethod}
                    >
                        저장
                    </Button>
                </div>
            </ModalDialog>
        </Modal>
    );
};

export default EditPayLinkInfoModal;
